import { appServiceClient } from '@/infrastructure/http/httpClient';

import {
  AplicarAcaoLotePayload,
  AplicarAcaoLoteResult,
  AplicarAcaoPayload,
  AplicarAcaoResult,
  CobrancaPreviaResult,
  FilaIgnorada,
  FilaReforcoSugestao,
  FilaResult,
  HistoricoResult,
  ListHistoricoQuery,
  MudancaDoDia,
  PreviaCobrancaPayload,
} from '../interfaces/fila';

function buildHistoricoQs(query: ListHistoricoQuery): string {
  const params = new URLSearchParams();
  if (query.page !== undefined) {
    params.set('page', String(query.page));
  }
  if (query.limit !== undefined) {
    params.set('limit', String(query.limit));
  }
  if (query.data !== undefined && query.data !== '') {
    params.set('data', query.data);
  }
  const qs = params.toString();
  return qs !== '' ? `?${qs}` : '';
}

class FilaRepository {
  async getFila(): Promise<FilaResult> {
    return appServiceClient.get<FilaResult>('fila');
  }

  /** As OPs tiradas da Fila, com quem ignorou e quando: a ficha "Ignoradas". */
  async ignoradas(): Promise<Array<FilaIgnorada>> {
    return appServiceClient.get<Array<FilaIgnorada>>('fila/ignoradas');
  }

  /** Quem viria de reforco para a celula do item. Nao grava nada. */
  async sugestaoDeReforco(uid: string): Promise<FilaReforcoSugestao> {
    return appServiceClient.get<FilaReforcoSugestao>(`fila/${uid}/reforco`);
  }

  async aplicarAcao(uid: string, payload: AplicarAcaoPayload): Promise<AplicarAcaoResult> {
    return appServiceClient.post<AplicarAcaoResult>(`fila/${uid}/acao`, { body: payload });
  }

  async aplicarAcaoEmLote(payload: AplicarAcaoLotePayload): Promise<AplicarAcaoLoteResult> {
    return appServiceClient.post<AplicarAcaoLoteResult>('fila/acoes', { body: payload });
  }

  /**
   * Desfaz UMA decisao do historico: a mudanca volta na OP e o item volta para a Fila
   * como nao resolvido. A fila inteira vem na resposta, como no aplicar.
   */
  async desfazerDecisao(id: string): Promise<AplicarAcaoResult> {
    return appServiceClient.post<AplicarAcaoResult>(`fila/decisoes/${id}/desfazer`);
  }

  /** Monta o que seria cobrado, agrupado por destinatario. Nao altera nada. */
  async previaCobranca(payload: PreviaCobrancaPayload): Promise<CobrancaPreviaResult> {
    return appServiceClient.post<CobrancaPreviaResult>('fila/cobranca/previa', { body: payload });
  }

  /** O que mudou HOJE: as reprogramacoes gravadas e as decisoes tomadas na fila. */
  async mudancasHoje(): Promise<Array<MudancaDoDia>> {
    return appServiceClient.get<Array<MudancaDoDia>>('fila/mudancas-hoje');
  }

  /** As decisoes de um dia. Sem `data` a API responde o dia de hoje. */
  async historico(query: ListHistoricoQuery = {}): Promise<HistoricoResult> {
    return appServiceClient.get<HistoricoResult>(`fila/historico${buildHistoricoQs(query)}`);
  }
}

export const filaRepository = new FilaRepository();
